'use es6';

const subscriptionDefaults = {
  id: 0,
  name: '',
  description: '',
  subscribed: false,
  category: '',
  channel: '',
  order: 0,
  internalName: ''
};
const subscriptionDefinitionDefaults = {
  id: 0,
  displayedProcess: '',
  displayedOperation: '',
  name: '',
  description: '',
  position: 0,
  checkboxChecked: true
};
const JSClass = (defaultProps = {}) => {
  class BaseJSClass {
    constructor(props = {}) {
      // Set default props
      Object.keys(defaultProps).forEach(key => {
        this[key] = key in props ? props[key] : defaultProps[key];
      });

      // Set custom props
      Object.keys(props).forEach(key => {
        this[key] = props[key];
      });
    }
  }
  return BaseJSClass;
};
const getSubscriptionName = ({
  category,
  channel,
  name
}) => {
  if (!category && !channel) {
    return name;
  }
  const gdprInfo = category && channel ? `${category} ${channel}` : category || channel;
  return `${gdprInfo} | ${name}`;
};
export class Subscription extends JSClass(subscriptionDefaults) {
  getDisplayName() {
    return getSubscriptionName(this);
  }
}
export class SubscriptionDefinition extends JSClass(subscriptionDefinitionDefaults) {
  getDisplayName() {
    return getSubscriptionName({
      category: this.displayedProcess,
      channel: this.displayedOperation,
      name: this.name
    });
  }
}